let organisingTeam = [
  {
    name: "Mădălina Codrescu",
    function: "Coordonator",
    img: "https://i.imgur.com/sdlqiru.jpg",

  },
  {
    name: "Livia Pătru",
    function: "Responsabil Academic",
    img: "https://i.imgur.com/V6Le7vr.jpg",

  },
  {
    name: "Iulia Vasile",
    function: "Responsabil Relații Publice",
    img: "https://i.imgur.com/ZoN6g9j.jpg",

  },
  {
    name: "Ionuț Diaconu",
    function: "Responsabil Resurse Umane",
    img: "https://i.imgur.com/EbTCt7n.jpg",
  },
  {
    name: "Ștefan Mircea",
    function: "Responsabil Logistic",
    img: "https://i.imgur.com/eJTvsc9.jpg",

  },
  {
    name: "Mihaela Stoica",
    function: "Responsabil Fundraisng",
    img: "https://i.imgur.com/8df0tRP.jpg",

  },


]

export default organisingTeam;